import { eyebrowFont } from '@config/mui-theme'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.contrastText,
      marginBottom: 0,
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(5),
      [theme.breakpoints.up('lg')]: {
        paddingTop: theme.spacing(16),
        paddingBottom: theme.spacing(10),
      },
    },
    outerContainer: {
      background: theme.palette.backgroundColor || 'unset',
    },
    overline: {
      color: theme.palette.grey.dark,
      lineHeight: '14px',
    },
    image: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
    spotlightImage: {
      height: 'auto',
      width: '100%',
      objectFit: 'contain',
      [theme.breakpoints.down('sm')]: {
        height: '100%',
        objectFit: 'cover',
      },
    },
    gridContainer: ({ flipped }) => ({
      flexDirection: 'column-reverse',
      background: theme.palette.backgroundColor || 'unset',
      [theme.breakpoints.up('md')]: {
        flexDirection: flipped ? 'row-reverse' : 'row',
        alignItems: 'center',
        minHeight: '33.125rem',
      },
      '&>div': {
        zIndex: '99',
      },
    }),
    mediaContainer: ({ variant }) => ({
      [theme.breakpoints.up('md')]: {
        position: variant && 'absolute',
        right: variant && '0',
        width: variant && '120%',
        '&>div>button': {
          borderRadius: variant && '0',
        },
      },
    }),
    button: {
      fontFamily: eyebrowFont,
      fontWeight: '700',
      letterSpacing: '0.4px',
      borderRadius: '4px',
      height: 'inherit',
      padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
      '&.MuiButton-contained': {
        boxShadow: theme.shadows[2],
      },

      [theme.breakpoints.only('xs')]: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      },
    },
    headline: {
      color: theme.palette.headingColor,
    },
    headerLine: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    featuredEyebrow: {
      color: theme.palette.eyebrowColor || theme.palette.primary.dark,
    },
    supportiveCopy: {
      color: theme.palette.supportiveCopyColor || '#000',
    },
    primaryCta: {
      color: theme.palette.primaryCtaColor || theme.palette.primary.contrastText,
      background: theme.palette.primaryCtaBackgroundColor || theme.palette.blue.main,
      '&:hover': {
        color: theme.palette.primaryCtaHoverColor || theme.palette.primary.contrastText,
        background: theme.palette.primaryCtaHoverBackgroundColor || theme.palette.secondary.light,
      },
    },
    secondaryCta: {
      color: theme.palette.secondaryCtaColor || theme.palette.blue.main,
      '&:hover': {
        color: theme.palette.supportiveCopyColor || theme.palette.blue.dark,
      },
    },
    headerCta: {
      padding: 0,
    },
    mCta: {
      display: 'flex',
      justifyContent: 'center',
    },
    previewContainer: {
      display: 'flex',
      gap: '2rem',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '0',
      },
    },
    previewimageContainer: {
      flexBasis: '200px',
      height: '125px',
      width: '200px',
      [theme.breakpoints.down('sm')]: {
        height: '250px',
        width: '100%',
      },
    },
    leftGrid: {
      height: '100%',
      flexDirection: 'column',
      display: 'flex',
    },
    rightGrid: {
      height: '100%',
      flexDirection: 'column',
      display: 'flex',
      gap: '2rem',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    previewNoImageContainer: {
      flexGrow: '1',
      flexBasis: '0',
      minHeight: '100px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    previewHeadline: {
      [theme.breakpoints.down('sm')]: {
        marginTop: '1rem',
      },
    },
    previewCta: {
      paddingLeft: '0',
    },
    mediumCta: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(6),
      },
    },
    divider: {
      height: '1px',
      backgroundColor: theme.palette.primary.light,
    },
    videoContainer: {
      objectFit: 'cover',
      width: '100%',
      height: '70vh',
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        height: '60vh',
      },
    },
    buttonContainer: {
      left: '35px',
      bottom: '20px',
      display: 'flex',
      '&>button:nth-child(1)': {
        marginRight: theme.spacing(1),
        paddingLeft: '10px',
      },
      [theme.breakpoints.down('sm')]: {
        left: 'auto',
        bottom: '330px',
        right: '16px',
      },
    },
    videoButton: {
      backgroundColor: theme.palette.secondary.dark,
      padding: '10px',
      paddingLeft: '15px',
      height: '42px',
      width: '42px',
      border: 'none',
      '&:focus': {
        outline: '3px solid white',
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    ctaContainer: {
      [theme.breakpoints.up('md')]: {
        position: 'absolute',
        bottom: ({ offset }) => `${offset}px`,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'flex-end',
      },
    },
    textContainer: {
      '&>div>ul>li': {
        marginBottom: '0 !important',
        '&>div': {
          marginBottom: '0 !important',
        },
        '&:before': {
          backgroundColor: 'black',
        },
      },
    },
  }
})

export default useStyles
